import React from 'react';

import '../../assets/css/Home.css';

function Footer() {
    return (
        <footer className="footer">
            <p>Copyright © Digitarian 2020.</p>
        </footer>
    );
}

export default Footer;
